import { ChangeDetectionStrategy, Component, computed } from '@angular/core'

import { SectionBasic } from 'app/core/cms/generated/api-types'
import { baseContainerWidth } from 'app/static/style-vars.const'
import { explicitComputed } from 'app/utils/signal-utils'

import { CmsBlock } from '../../cms-block'
import { ContainerInfo } from '../../container-info'
import { InsertDynamicContentDirective } from '../../insert-dynamic-content.directive'
import { LayoutContainer } from '../layout-container'
import { parseDesign } from '../section-utils'

@Component({
  selector: 'pai-section-basic',
  templateUrl: './section-basic.component.html',
  styleUrls: ['./section-basic.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.size]': 'design().containerWidth',
    '[attr.background]': 'design().background',
    '[attr.innerShadow]': 'design().innerShadow',
    '[attr.alignment]': 'data().alignment',
  },
  imports: [InsertDynamicContentDirective],
  providers: [
    { provide: CmsBlock, useExisting: SectionBasicComponent },
    { provide: LayoutContainer, useExisting: SectionBasicComponent },
  ],
})
export class SectionBasicComponent extends CmsBlock<SectionBasic> implements LayoutContainer {
  readonly __typename = 'SectionBasic'
  protected readonly design = computed(() => parseDesign(this.data().design))

  readonly containerInfo = explicitComputed(
    this.design,
    ({ containerWidth: size }): ContainerInfo => ({
      maxWidthAtMd: size === 'small' ? `${baseContainerWidth['small']}px` : '100vw',
      maxWidthAtLg: size === 'large' ? '100vw' : /* sm or md */ `${baseContainerWidth[size]}px`,
      maxWidthAtXl: `${baseContainerWidth[size]}px`,
    }),
  )
}
